import React from 'react';

export const EmptyIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="none" viewBox="0 0 151 148" {...props} xmlns="http://www.w3.org/2000/svg">
		<path
			clipRule="evenodd"
			d="M129.285 135.877c-16.725 13.262-44.22 11.648-69.503 6.675-25.25-5.013-48.325-13.417-55.424-28.707-7.102-15.325 1.776-37.497 11.384-56.051 9.64-18.591 19.977-33.523 37.852-44.066C71.429 3.153 96.842-2.998 115.48 6.532c18.64 9.531 30.582 34.774 33.571 61.412 2.958 26.675-3.004 54.705-19.767 67.933Z"
			stroke="#ABE1E1"
			strokeWidth="1.971"
		/>
		<path
			d="M72.317 59.88h2.75a1.376 1.376 0 0 0 0-2.755h-2.75c-.76 0-1.375.617-1.375 1.378 0 .76.615 1.378 1.375 1.378Zm-8.25 0h2.75a1.376 1.376 0 0 0 0-2.755h-2.75c-.76 0-1.375.617-1.375 1.378 0 .76.615 1.378 1.375 1.378Zm-8.25 0h2.75a1.376 1.376 0 0 0 0-2.755h-2.75c-.76 0-1.375.617-1.375 1.378 0 .76.615 1.378 1.375 1.378Z"
			fill="#008484"
		/>
		<path
			clipRule="evenodd"
			d="M48.942 55.748a4.129 4.129 0 0 1 4.125-4.133h57.75a4.129 4.129 0 0 1 4.125 4.133v41.33a4.13 4.13 0 0 1-4.125 4.133h-57.75a4.13 4.13 0 0 1-4.125-4.133v-41.33Zm63.25 6.888h-60.5v-6.888c0-.761.615-1.378 1.375-1.378h57.75c.759 0 1.375.617 1.375 1.378v6.888Zm0 34.441c0 .761-.616 1.378-1.375 1.378h-57.75c-.76 0-1.375-.617-1.375-1.377V65.39h60.5v31.686Z"
			fill="#A9AEB4"
			fillRule="evenodd"
		/>
		<path
			d="M93.918 72.68a1.374 1.374 0 0 0-1.953 0l-.399.412-.398-.413a1.378 1.378 0 0 0-1.953 0 1.385 1.385 0 0 0 0 1.956l.413.4-.413.4a1.38 1.38 0 0 0 0 1.956 1.373 1.373 0 0 0 1.953 0l.398-.413.4.413a1.373 1.373 0 0 0 1.952 0 1.38 1.38 0 0 0 0-1.956l-.413-.4.413-.4a1.38 1.38 0 0 0 0-1.956Zm-19.25 2.755-.413-.4.413-.4a1.385 1.385 0 0 0 0-1.956 1.378 1.378 0 0 0-1.953 0l-.399.413-.398-.413a1.379 1.379 0 0 0-2.31.62c-.128.478.008.987.357 1.337l.413.4-.413.399a1.38 1.38 0 0 0 0 1.956 1.373 1.373 0 0 0 1.953 0l.398-.413.4.413a1.373 1.373 0 0 0 1.952 0 1.38 1.38 0 0 0 0-1.956Zm15.331 14.079a1.374 1.374 0 0 1-1.884.482 11.971 11.971 0 0 0-12.375 0c-.642.291-1.4.048-1.755-.563a1.38 1.38 0 0 1 .38-1.806 14.675 14.675 0 0 1 15.125 0 1.379 1.379 0 0 1 .51 1.887Z"
			fill="#008484"
		/>
	</svg>
);
